import { formatDistanceToNow } from 'date-fns';

/**
 * Safe wrapper around date-fns formatDistanceToNow.
 * Returns an empty string instead of throwing when the value is missing or invalid.
 */
export const safeTimeAgo = (
  value: string | number | Date | null | undefined,
  options?: { addSuffix?: boolean }
): string => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return formatDistanceToNow(d, options);
  } catch {
    return '';
  }
};
